/**
 * kattintásra megmutatja a jelszó értékét
 * @author sarkiroka on 2016.07.04.
 */
import link from './link';
export default function (app) {
	app.directive('passwordView', [function () {
		return {
			restrict: 'A',
			link: link
		};
	}]);
};
